import React from "react";
import ReportTotalFunction from "./ReportTotalFunction";

const listdata = [
  { value: "ex_by_function_new", title: "Personnel Exp. By Function" },
  { value: "ex_by_function_new", title: "Other NDR Exp. by Function" },
  { value: "ex_by_function", title: "Debt Service by Function" },
  { value: "ex_by_function_new", title: "Capital Exp. By Function" },
];

function ExpenditureByFunction() {
  return (
    <ReportTotalFunction
      type="total_ex_by_function"
      title="Total Exp. by Function"
      route="/reports"
      options={listdata}
    />
  );
}

export default ExpenditureByFunction;
